<!--
 * @Description: 
 * @Author: yuxin
 * @Date: 2024-12-10 09:56:01
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-06-24 17:36:05
 * @FilePath: \mgr_web\src\views\mass\SOP\CustomerSOP.vue
-->

<template>
  <div class="sop">
    <el-tabs v-model="activeName">
      <el-tab-pane v-if="roleObj.KHSOPhfsop" label="回访SOP" name="first"
        ><ReturnVisitSOPList></ReturnVisitSOPList
      ></el-tab-pane>
      <el-tab-pane v-if="roleObj.KHSOPxzhysop" label="新增好友SOP" name="second"
        ><NewFriendsSOPList></NewFriendsSOPList
      ></el-tab-pane>
      <el-tab-pane v-if="roleObj.KHSOPpyqsop" label="朋友圈SOP" name="third"
        ><WechatMomentsSOPList></WechatMomentsSOPList
      ></el-tab-pane>
      <el-tab-pane v-if="roleObj.KHSOPsrtxsop" label="生日提醒SOP" name="fourth"
        ><BirthdayReminderList></BirthdayReminderList
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ReturnVisitSOPList from "@/views/mass/SOP/components/returnVisitSOPList.vue";
import NewFriendsSOPList from "@/views/mass/SOP/components/newFriendsSOPList.vue";
import WechatMomentsSOPList from "@/views/mass/SOP/components/wechatMomentsSOPList.vue";
import BirthdayReminderList from "@/views/mass/SOP/components/birthdayReminderList.vue";
export default {
  name: "customerSOP",
  components: {
    ReturnVisitSOPList,
    NewFriendsSOPList,
    WechatMomentsSOPList,
    BirthdayReminderList,
  },
  data() {
    return {
      activeName: "first",
      roleObj: {
        KHSOPhfsop: false, // 回访SOP
        KHSOPxzhysop: false, // 新增好友SOP
        KHSOPpyqsop: false, // 朋友圈SOP
        KHSOPsrtxsop: false, // 生日提醒
      },
    };
  },
  created() {},
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "客户SOP") {
              let senBtnAuthority = item.cfunBu;
              senBtnAuthority.forEach((item) => {
                this.roleObj[item] = true;
              });
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    // 选择范围弹窗
  },
};
</script>
<style lang="scss" scoped>
.sop {
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/ .el-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex: 1;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
</style>
